export default "__VITE_ASSET__CSd8i5jE__"